import React, {useEffect, useState} from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {Icon, Loader} from '../components';
import ShowItem from "../ShowItem";
import Block from "../Block";
import useCustomTable from "../tables/useCustomTable";
// import IabLogo from "../../../assets/images/layout4/iab-logo.png";
import Table from "../tables/Table";
import {Badge} from "react-bootstrap";
import VendorForm from "./VendorForm";
import styled from "styled-components";
import {useDebug} from "../utils";
import useActionConfirmation from "../useActionConfirmation";

const StyledBlock = styled(Block)`
  .config-removed {
    font-style: italic;
    opacity: 0.5
  }
`

export const VendorModal = ({vendor, show, setShow, updateVendor, vendorFormProps, params, addVendor, removeVendor, loaderProps}) => {
  const { t } = useTranslation();
  const [editable, setEditable] = useState(false)
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const [vendorIsGoogle, setVendorIsGoogle] = useState(null)

  const {Confirmation, confirmationProps, confirm} = useActionConfirmation()

  const handleClose = () => {
    setShow(false);
    setEditable(false)
  }

  useEffect(() => {
    vendor && setVendorIsGoogle(vendor.googleId != null)
  }, [vendor])

  if (!vendor) {
    return <></>
  }

  const onUpdate = (data) => {
    updateVendor({...params, vendorId: vendor.id, vendor: data}).unwrap().then(() => setEditable(false))
  }

  const onRemove = () => {
    confirm(() => removeVendor({...params, vendorId: vendor.id}).unwrap().then(handleClose))
  }

  const onAdd = () => {
    confirm(() => addVendor({...params, vendorId: vendor.id}).unwrap().then(handleClose))
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} size={"lg"}>
        <Modal.Body>
          <Loader {...loaderProps}>
            {!editable && <VendorShow vendor={vendor}/>}
            {editable && <VendorForm
              vendor={vendor}
              setSubmitButtonProps={setSubmitButtonProps}
              onSubmit={onUpdate}
              {...vendorFormProps}/>}
          </Loader>
        </Modal.Body>
        {loaderProps.success && <Modal.Footer>
          <Button variant="secondary" onClick={() => editable ? setEditable(false) : handleClose()}>
            {t("cancel")}
          </Button>
          {!editable && !vendorIsGoogle && <Button onClick={() => setEditable(true)}>
            <Icon icon='edit' text={t("edit")}/>
          </Button>}
          {editable && <Button key="submit" type="submit" variant="primary" {...submitButtonProps}>
            <Icon icon='save' text={t("save")}/>
          </Button>}
          {!editable && vendor?.active && <Button onClick={onRemove} variant="primary">
            <Icon icon='trash' text={t("remove")}/>
          </Button>}
          {!editable && !vendor?.active && <Button onClick={onAdd} variant="primary">
            <Icon icon='trash' text={t("add")}/>
          </Button>}

        </Modal.Footer>}
      </Modal>
      <Confirmation {...confirmationProps} />
    </>
  );
}

function VendorShow({vendor}) {
  const { t } = useTranslation();

  const columns = [{
    Cell: ({row}) => {
      if (row.original.iabId) {
        // return <img src={IabLogo} style={{height: "24px"}}/>
        return <></>
      } else {
        return <></>
      }
    },
    accessor: 'iabLogo',
    maxWidth: 5,
    minWidth: 5,
    disableSortBy: true
  },{
    Header: 'Name',
    accessor: 'name',
    Cell: ({row}) => {
      return <div style={{display: "flex", alignItems: "center"}}>
        {row.original.removed && <div><Badge variant={"secondary"}>REMOVED</Badge>&nbsp;</div>}
        <div><Badge variant={"primary"}>{t(`cmp.${row.original.type}`)}</Badge>&nbsp;</div>
        {row.original.type == 'purpose' && row.original.legInt && <div><Badge variant={"secondary"}>{t(`cmp.legInt`)}</Badge>&nbsp;</div>}
        <div style={{flex: 1}}>{row.original.name}</div>
      </div>
    },
    width: 500
  },{
    Header: 'IAB id',
    accessor: 'iabId',
    width: 50
  }];

  const tableOptions = {
    sortable: false,
    paginate: false,
    filterable: false
  };

  const {
    tableProps
  } = useCustomTable(tableOptions)

  const getRowProps = (row) => {
    return row.original.removed ? {
      className: 'config-removed'
    } : {}
  }

  return <>
    <div>
      <ShowItem label={t("cmp.name")} value={vendor.name} darkBorder={true} />
      {!vendor.iabId && !vendor.googleId && <ShowItem label={t("cmp.key")} value={vendor.key} darkBorder={true} />}
      {vendor.iabId && <ShowItem label={"ID"} value={vendor.iabId} darkBorder={true} />}
      {vendor.googleId && <ShowItem label={"ID"} value={vendor.googleId} darkBorder={true} />}
      <ShowItem label={t("cmp.privacyPolicyUrl")} value={vendor.policyUrl} darkBorder={true} className={"mb-2"}/>
    </div>
    <StyledBlock className="mb-0">
      <Table
        data={[...vendor.specialFeatures, ...vendor.purposes.sort((a,b) => ((a.iabId || 1000) - (b.iabId || 1000)))]}
        columns={columns}
        getRowProps={getRowProps}
        {...tableProps} />
    </StyledBlock>
  </>
}

